import { 
  Paper, 
  Stack, 
  Typography, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button, } from "@mui/material";
import CustomButton from "components/atoms/CustomButton";
import CustomRightDrawer from "components/atoms/CustomRightDrawer";
import CustomTab from "components/atoms/CustomTab";

import SearchBar from "components/atoms/SearchBar";

import React, { useState } from "react";
import { useQueryClient, useMutation } from "react-query";

import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import {
  GET_ALL_PHARMACY_PRODUCTS,
  GET_PHARMACY_DISPENSE_HISTORY,
} from "utils/reactQueryKeys";

import Header from "../components/Header";

import CreateNewProductModal from "../requisitionHistory/modalContents/CreateNewProductModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportToExcel } from "utils/exportToExcel";
import CsvDownloader from "react-csv-downloader";
import CustomMenu from "components/atoms/CustomMenu";
import AvailableStockTable from "components/molecules/tabels/pharmacy/AvailableStockTable";
import DispenseHistoryTable from "components/molecules/tabels/pharmacy/DispenseHistoryTable";
import CustomLoader from "components/atoms/CustomLoader";
import { currencyFormatter, numberFormatter } from "utils/numberFormatter";
import AddBatchToProduct from "./modalContent/AddBatchToProduct";

import ImportProductsModal from "../requisitionHistory/modalContents/ImportProductsModal";
import axios from "axios";
import { toast } from "react-toastify"; 
import { request } from "utils/axios-utils"; 

const pageSize = 10;

const formatExportData = (data) => {
  let formatted = [];
  if (data?.length) {
    formatted = data.map((d) => {
      const copy = structuredClone(d);
      delete copy.id;
      const formartedData = {
        ...copy,
        drugType: `${copy?.drugType?.name || ""}`,
        genericName: `${copy?.genericName?.activeIngredient}`,
        availableQuantity: numberFormatter(copy?.availableQuantity || 0),
        salesPrice: currencyFormatter(copy?.salesPrice || 0),
        expiryDate: copy?.expiryDate 
          ? new Date(copy.expiryDate).toLocaleDateString() 
          : "N/A",
      };
      return formartedData;
    });
  }
  return formatted;
};
const formatExportData1 = (data) => {
  let formatted = [];
  if (data?.length) {
    formatted = data.map((d) => {
      const copy = structuredClone(d);
      let item = {};
      copy.items.forEach((prod, i) => {
        item[`item_${i + 1}`] = prod?.product?.drugName;
      });

      const formartedData = {
        ...copy,
        ...item,
        pharmacistId: copy?.pharmacist?._id,
        pharmacist: copy?.pharmacist?.fullName,
        doctorId: copy?.doctor?._id,
        doctor: copy?.doctor?.fullName,
        patientName: `${copy?.patient?.firstName} ${copy?.patient?.lastName}`,
        patientId: `${copy?.patient?._id}`,

        totalCost: currencyFormatter(copy?.totalCost || 0),
      };
      delete formartedData.id;

      delete formartedData.patient;
      delete formartedData.items;
      return formartedData;
    });
  }
  return formatted;
};

function PharmacyStockManagement() {
  const modalRef1 = React.useRef(null);
  const toggleModal1 = () => {
    modalRef1?.current?.handleToggle();
  };
  return (
    <>
      <Stack
        direction={{ xs: "column" }}
        sx={{
          gap: 4,
        }}
      >
        <Stack
          direction={"row"}
          width="100%"
          alignItems={"center"}
          justifyContent="space-between"
        >
          <Header title="Overview" />

          <CustomButton
            text={"Add Batch To Product"}
            variant="contained"
            color="secondary"
            onClick={toggleModal1}
          />
        </Stack>
        <Header title="Stock Management" />
        <TabWithTables />
      </Stack>
      <CustomRightDrawer ref={modalRef1} title="Add Batch To A Product">
        <AddBatchToProduct closeModal={toggleModal1} />
      </CustomRightDrawer>
    </>
  );
}
const navItems = [
  {
    label: "Available Stock",
    id: 1,
  },
  {
    label: "Dispense History",
    id: 2,
  },
];

const TabWithTables = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const [search, setsearch] = React.useState("");
  const queryClient = useQueryClient();

  const modalRef1 = React.useRef(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [currentPage1, setCurrentPage1] = React.useState(1);

  // 1. ADD REF FOR IMPORT MODAL
  const importModalRef = React.useRef(null);

  const [productToEdit, setProductToEdit] = React.useState(null);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
  const [productToDelete, setProductToDelete] = React.useState(null);

  const [selectedProductIds, setSelectedProductIds] = React.useState([]);
  const [bulkDeleteConfirmOpen, setBulkDeleteConfirmOpen] = React.useState(false);

  // ---------------------------------------------------------
  // [NEW] DELETE MUTATION
  // ---------------------------------------------------------
  const deleteMutation = useMutation(
    (id) => request({ 
      url: `/product/remove/${id}`, 
      method: "delete" 
    }),
    {
      onSuccess: () => {
        toast.success("Product deleted successfully");
        // Better: invalidate to trigger proper refetch (handles pagination/search state)
        queryClient.invalidateQueries([GET_ALL_PHARMACY_PRODUCTS]);
        // Or keep your existing manual refetch if preferred:
        // refetchProdutcs();
      },
      onError: (err) => {
        toast.error(err.response?.data?.message || "Failed to delete product");
      },
    }
  );

  // Bulk Delete Mutation
  const bulkDeleteMutation = useMutation(
    (ids) => request({ 
      url: `/product/remove-bulk`, 
      method: "post",
      data: { ids } 
    }),
    {
      onSuccess: () => {
        toast.success("Products deleted successfully");
        queryClient.invalidateQueries([GET_ALL_PHARMACY_PRODUCTS]);
        setSelectedProductIds([]); // Clear selection after success
      },
      onError: (err) => {
        toast.error(err.response?.data?.message || "Failed to delete products");
      },
    }
  );

  // ---------------------------------------------------------
  // [NEW] HANDLERS
  // ---------------------------------------------------------
  const handleEditRow = (row) => {
    // 1. Set the data to be edited
    // You might need to lift 'setProductToEdit' from the parent or define it here if the Modal is here
    // For this example, assuming the Modal is available or controlled here:
    setProductToEdit(row); 
    modalRef1?.current?.handleToggle();
  };

  const handleDeleteRow = (id) => {
    setProductToDelete(id);
    setDeleteConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    if (productToDelete) {
      deleteMutation.mutate(productToDelete);
    }
    setDeleteConfirmOpen(false);
    setProductToDelete(null);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmOpen(false);
    setProductToDelete(null);
  };

  const handleConfirmBulkDelete = () => {
    if (selectedProductIds.length > 0) {
      bulkDeleteMutation.mutate(selectedProductIds);
    }
    setBulkDeleteConfirmOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePageChange1 = (page) => {
    setCurrentPage1(page);
  };

  const { isLoading: productsLoading, data: pharmacyProducts } = useCustomQuery(
    [GET_ALL_PHARMACY_PRODUCTS, currentPage1],
    {
      url: `/product/getall?page=${currentPage1}&limit=${pageSize}&search=`,
      method: "get",
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  //search pharmacy products
  const {
    isLoading: searchLoading,
    isFetching,
    refetch: refetchProdutcs,
  } = useCustomQuery(
    [GET_ALL_PHARMACY_PRODUCTS, search],
    {
      url: `/product/getall?search=${search}&limit=${pageSize}`,
      method: "get",
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        queryClient.setQueryData(
          [GET_ALL_PHARMACY_PRODUCTS, currentPage1],
          (oldQueryData) => {
            if (search) {
              return {
                ...response,
                data: {
                  count: response.data.length,
                  products: [...response.data],
                },
              };
            }
            return {
              ...response,
            };
          }
        );
      },
    }
  );

  const { isLoading: productsHistoryLoading, data: pharmacyHistory } =
    useCustomQuery(
      [
        GET_PHARMACY_DISPENSE_HISTORY,
        {
          page: currentPage,
          limit: pageSize,
        },
      ],
      {
        url: `/prescription/completed`,
        method: "post",
        data: {
          page: currentPage,
          limit: pageSize,
        },
      },
      {
        refetchOnWindowFocus: false,
      }
    );

  //search dispense history
  const {
    isLoading: dispenseHistoryLoading,
    isFetching: dispenseHistoryRefetching,
    refetch: refetchDispenseHistory,
  } = useCustomQuery(
    [GET_PHARMACY_DISPENSE_HISTORY, search],
    {
      url: `/prescription/completed`,
      method: "post",
      data: {
        search,
      },
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        queryClient.setQueryData(
          [
            GET_PHARMACY_DISPENSE_HISTORY,
            {
              page: currentPage,
              limit: pageSize,
            },
          ],
          (oldQueryData) => {
            return {
              ...response,
            };
          }
        );
      },
    }
  );

  const handleExport = () => {
    if (currentTab === 0) {
      const data = formatExportData(pharmacyProducts?.data?.products);
      exportToExcel(data, "hms_pharmacy_available_stocks_excel");
    } else {
      const data = formatExportData1(pharmacyHistory?.data?.prescriptions);
      exportToExcel(data, "hms_pharmacy_dispense_history_excel");
    }
  };
  let tableToShow;

  switch (currentTab) {
    case 0:
      tableToShow = (
        <AvailableStockTable
          data={pharmacyProducts?.data || []}
          handlePageChange={handlePageChange1}
          currentPage={currentPage1}
          onEdit={handleEditRow}
          onDelete={handleDeleteRow}
          selectedIds={selectedProductIds}
          onSelectionChange={(newSelectionIds) => setSelectedProductIds(newSelectionIds)}
        />
      );
      break;
    case 1:
      tableToShow = (
        <DispenseHistoryTable
          data={pharmacyHistory?.data || {}}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      );
      break;

    default:
      break;
  }
  const handleSetCurrentTab = (tab) => {
    setsearch("");
    setCurrentTab(tab);
  };
  const handleSearch = () => {
    if (currentTab === 0) {
      refetchProdutcs();
    } else {
      refetchDispenseHistory();
    }
  };

  return (
    <>
      <Paper sx={{ p: 4, pt: 6 }}>
        <Stack direction="column">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
          >
            <CustomTab
              value={currentTab}
              setValue={handleSetCurrentTab}
              navItems={navItems}
              sx={{ width: { xs: "100%", sm: "50%" }, flexGrow: 1 }}
            />
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent={{ xs: "center", sm: "space-between" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              spacing={1.5}
            >
              <SearchBar
                search={search}
                setsearch={setsearch}
                isLoading={
                  currentTab === 0
                    ? searchLoading || isFetching
                    : dispenseHistoryLoading || dispenseHistoryRefetching
                }
                refetch={handleSearch}
                placeholder="Search"
              />

              {/* 2. ADD IMPORT BUTTON HERE */}
              <CustomButton
                text="Import"
                variant="outlined"
                startIcon={<FileDownloadOutlinedIcon sx={{ transform: "rotate(180deg)" }} />} 
                onClick={() => importModalRef?.current?.handleToggle()}
              />

              <CustomButton
                text="Export"
                variant="outlined"
                startIcon={<FileDownloadOutlinedIcon />}
                onClick={handleExport}
              />

              <CustomButton
                text={"Create Product"}
                variant="contained"
                color="secondary"
                onClick={() => {
                  setProductToEdit(null); // ← ensures it's create mode
                  modalRef1?.current?.handleToggle();
                }}
              />

              {selectedProductIds.length > 0 && currentTab === 0 && (
                <CustomButton
                  text={`Delete Selected (${selectedProductIds.length})`}
                  variant="contained"
                  color="error" // Show it as a destructive action
                  onClick={() => setBulkDeleteConfirmOpen(true)}
                  disabled={bulkDeleteMutation.isLoading}
                />
              )}

              {/* <CustomButton
                text={"create Requesition"}
                variant="contained"
                color="secondary"
                onClick={openDrawerHandler}
              /> */}
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          {productsLoading || productsHistoryLoading ? (
            <CustomLoader />
          ) : (
            tableToShow
          )}
        </Stack>
      </Paper>

      <CustomRightDrawer
        ref={modalRef1}
        title={productToEdit ? "Edit Product" : "Create New Product"} // [CHANGED] Dynamic Title
        subTitle=""
      >
        <CreateNewProductModal
          closeModal={() => modalRef1?.current?.handleToggle()}
          initialData={productToEdit} // [NEW] Pass the data to the form
          isEditMode={!!productToEdit} // [NEW] Flag for logic inside the modal
        />
      </CustomRightDrawer>

      {/* 3. ADD THE IMPORT DRAWER COMPONENT HERE */}
      <CustomRightDrawer
        ref={importModalRef}
        title="Bulk Import Products"
        subTitle="Upload CSV"
      >
        <ImportProductsModal
          closeModal={() => importModalRef?.current?.handleToggle()}
        />
      </CustomRightDrawer>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-confirmation-dialog"
      >
        <DialogTitle id="delete-confirmation-dialog">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this product? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Delete Confirmation Dialog */}
      <Dialog
        open={bulkDeleteConfirmOpen}
        onClose={() => setBulkDeleteConfirmOpen(false)}
      >
        <DialogTitle>Confirm Bulk Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {selectedProductIds.length} selected products? All associated batches will also be removed. This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkDeleteConfirmOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBulkDelete}
            color="error"
            variant="contained"
            disabled={bulkDeleteMutation.isLoading}
          >
            {bulkDeleteMutation.isLoading ? "Deleting..." : "Delete All"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PharmacyStockManagement;
